$bog_vmap_app_inspect_flex $mol_list
	value*? \
	editable true
	rows /
		<= Width $mol_form_field
			name \Ширина
			control <= Width_pick $mol_switch
				enabled <= editable
				value? <=> width? \
				options *
					390px \мобильная
					768px \планшет
					1280px \десктоп
		<= Direction $mol_form_field
			name \Направление
			control <= Direction_pick $mol_switch
				enabled <= editable
				value? <=> direction? \
				options *
					column \колонкой
					row \рядом
		<= Across $mol_form_field
			name \Поперёк
			control <= Across_pick $mol_switch
				enabled <= editable
				value? <=> across? \
				options *
					flex-start \к началу
					center \по центру
					flex-end \к концу
					stretch \во всю
		<= Along $mol_form_field
			name \Вдоль
			control <= Along_pick $mol_switch
				enabled <= editable
				value? <=> along? \
				options *
					flex-start \к началу
					center \по центру
					flex-end \к концу
					space-between \по краям
		<= Gap $mol_form_field
			name \Зазор
			control <= Gap_field $mol_string
				hint \1rem
				value? <=> gap? \
				enabled <= editable
		<= Grow $mol_form_field
			name \Растяжение
			control <= Grow_check $mol_check
				title \занимать свободное место
				checked? <=> grow? false
				enabled <= editable
